import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, ElementRef, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-profile-editor-dialog',
  templateUrl: './profile-editor-dialog.component.html',
  styleUrls: ['./profile-editor-dialog.component.scss']
})
export class ProfileEditorDialogComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  uploadInProgress = false;
  uploadProgress = 0;
  uploadedImageUrl: string | null = null;
  uploadedFileName: string | null = null;
  uploadedMimeType: string | null = null;
  cid = localStorage.getItem(Constant.enterPriseKey);
  basePath = environment.commonImageApi + '/profile/';
  showUpload: boolean = false;
  title: string;
  constructor(
    public dialogRef: MatDialogRef<ProfileEditorDialogComponent>,
    private fileUploadService: FileUploadService,
    private productService: ProductService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    let image = data.imageUrl;
    this.uploadedFileName = image;
    this.uploadedImageUrl = this.basePath + image + "&cid=" + this.cid;

    if (image == null || image == "" || image == undefined) {

      this.showUpload = false;
      this.title = "Add Profile Image";

    } else {
      this.showUpload = true;
      this.title = "Edit Profile Image";
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });


  }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }


  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;

    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      const formData = new FormData();
      formData.append(
        'files',
        file,
        file.name.replace(/\s/g, "_").replace(/\(/g, '_').replace(/\)/g, '_')
      );

      this.uploadInProgress = true;

      this.fileUploadService.normalUploadFiles(formData, 'profile', 'calsoftgroup.com').subscribe({
        next: (res: any) => {
          if (res && res.status_code === '500') {
            this.snackbar.open(res.status_message || 'An error occurred during upload', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
            this.uploadInProgress = false;
            return;
          }
          this.uploadProgress = 100;
          const fileName = res?.productEntityMediaGallery?.[0]?.fileName ?? '';
          if (fileName) {
            this.handleUploadedFile(fileName, file.type);
          }
        },
        error: () => {
          this.snackbar.open('Image upload failed', 'Close', { duration: 3000 });
          this.uploadInProgress = false;
        }
      });
    }
  }



  handleUploadedFile(fileName: string, mime: string) {


    fileName = fileName.split('/').pop() || '';
    this.uploadedFileName = fileName;
    this.uploadedImageUrl = this.basePath + fileName + "&cid=" + this.cid;
    this.uploadedMimeType = mime;

    this.uploadInProgress = false;
    // ✅ Just show preview, don’t close
  }

  onSaveChanges(): void {
    if (this.uploadedFileName && this.uploadedImageUrl && this.uploadedMimeType) {
      this.dialogRef.close({
        action: 'upload',
        fileName: this.uploadedFileName,
        mediaUrl: this.uploadedImageUrl,
        mimeType: this.uploadedMimeType
      });
    }
  }

  onCancelUpload(): void {

    this.showUpload = true;
  }

  triggerFileInput(fileInput: HTMLInputElement): void {
    fileInput.click();
    this.showUpload = true;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  imagesToRemoved: any = [];
  deleteImage() {

    let smallImage = "/profile/" + this.uploadedFileName;
    this.imagesToRemoved.push(smallImage);

    this.productService.deleteImage(this.imagesToRemoved).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.dialogRef.close({ action: 'remove' });

        }
        else {

        }
      },
      (err) => {

      });

  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}